import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { StoreButtons } from "@/components/landing/StoreButtons";

export const DownloadModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="download-modal"
        className="bg-charcoal border border-vitality/30 max-w-md rounded-2xl p-8 text-center"
      >
        <DialogTitle className="font-heading text-3xl font-black uppercase tracking-tight text-white">
          Get The <span className="text-vitality">AlphaPulse</span> App
        </DialogTitle>
        <DialogDescription className="text-white/60 text-sm">
          Download AlphaPulse to start your free plan and unlock workouts, nutrition and progress tracking.
        </DialogDescription>
        <div className="mt-2 flex justify-center">
          <StoreButtons />
        </div>
      </DialogContent>
    </Dialog>
  );
};
